import $ from 'jquery';
import Swal from 'sweetalert2';
import { confirmAction } from './sweetalert';

export function initTableUtils() {
    const pageIdElem = document.getElementById('page-id');
    const pageId = pageIdElem ? pageIdElem.dataset.page : '';

    // --- Native Client-Side DataTables Initialization ---
    $('.datatable:not([data-ajax-url])').each(function () {
        if (this.classList.contains('native-table-init')) return;
        this.classList.add('native-table-init');

        const table = this;
        const card = table.closest('.card');
        if (!card) return;

        console.log('[NativeClientTable] Initializing native JS client table:', table.id);

        const tableBody = table.querySelector('tbody') || (() => {
            const tbody = document.createElement('tbody');
            table.appendChild(tbody);
            return tbody;
        })();

        // Parse column headers (th elements)
        const ths = table.querySelectorAll('thead th');

        // Extract original rows, excluding the empty placeholder row
        const originalRows = Array.from(tableBody.querySelectorAll('tr')).filter(row => {
            return !row.querySelector('td[colspan]') || !row.textContent.includes('Tidak ada data tersedia');
        });

        // 1. Locate or create card header controls
        let cardHeader = card.querySelector('.card-header');
        if (!cardHeader) {
            cardHeader = document.createElement('div');
            cardHeader.className = 'card-header bg-white border-bottom-0 pt-4 pb-0 px-4';
            card.insertBefore(cardHeader, card.firstChild);
        } else {
            // Remove title & icon as requested
            cardHeader.innerHTML = '';
        }
        cardHeader.classList.add('d-md-flex', 'align-items-center', 'justify-content-between');

        let lengthMenu = card.querySelector('.native-length-menu') || card.querySelector('#nativeLengthMenu');
        let searchInput = card.querySelector('.native-search-input') || card.querySelector('#nativeSearchInput');

        if (!lengthMenu || !searchInput) {
            const controlsContainer = document.createElement('div');
            controlsContainer.className = 'd-flex flex-column flex-sm-row align-items-sm-center gap-3 ms-auto';
            controlsContainer.innerHTML = `
                <div class="d-flex align-items-center gap-2">
                    <span class="text-muted small fw-medium text-nowrap">Show:</span>
                    <select class="form-select form-select-sm rounded-pill px-3 shadow-none border-light-subtle native-length-menu" style="width: 80px;">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50" selected>50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="position-relative" style="min-width: 260px;">
                    <span class="position-absolute top-50 start-0 translate-middle-y ps-3 text-muted">
                        <i class="bi bi-search"></i>
                    </span>
                    <input type="text" class="form-control form-control-sm rounded-pill ps-5 pe-3 shadow-none border-light-subtle native-search-input" placeholder="Cari...">
                </div>
            `;
            cardHeader.appendChild(controlsContainer);
            lengthMenu = controlsContainer.querySelector('.native-length-menu');
            searchInput = controlsContainer.querySelector('.native-search-input');
        }

        // 2. Locate or create footer controls
        let tableInfo = card.querySelector('.native-table-info') || card.querySelector('#nativeTableInfo');
        let paginationUl = card.querySelector('.native-pagination') || card.querySelector('#nativePagination');

        if (!tableInfo || !paginationUl) {
            let footer = card.querySelector('.native-footer-controls');
            if (!footer) {
                footer = document.createElement('div');
                footer.className = 'row mt-4 align-items-center native-footer-controls';
                footer.innerHTML = `
                    <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0">
                        <span class="text-muted fw-medium small native-table-info"></span>
                    </div>
                    <div class="col-sm-12 col-md-7 d-flex justify-content-center justify-content-md-end">
                        <nav aria-label="Page navigation">
                            <ul class="pagination pagination-sm mb-0 rounded-pill gap-1 native-pagination">
                            </ul>
                        </nav>
                    </div>
                `;
                const cardBody = card.querySelector('.card-body');
                if (cardBody) {
                    cardBody.appendChild(footer);
                } else {
                    card.appendChild(footer);
                }
            }
            tableInfo = footer.querySelector('.native-table-info');
            paginationUl = footer.querySelector('.native-pagination');
        }

        // 3. State variables
        let start = 0;
        let length = parseInt(lengthMenu ? lengthMenu.value : 50);
        let search = '';
        let orderColumnIndex = null;
        let orderDir = 'asc';

        // 4. Setup sorting headers
        ths.forEach((th, idx) => {
            const noSort = th.classList.contains('no-sort');
            if (!noSort) {
                th.classList.add('sortable-header', 'cursor-pointer');
                th.style.userSelect = 'none';
                if (!th.querySelector('.sort-icon')) {
                    const icon = document.createElement('i');
                    icon.className = 'bi bi-arrow-down-up text-muted ms-1 small sort-icon';
                    th.appendChild(icon);
                }

                th.addEventListener('click', function () {
                    if (orderColumnIndex === idx) {
                        orderDir = orderDir === 'asc' ? 'desc' : 'asc';
                    } else {
                        orderColumnIndex = idx;
                        orderDir = 'asc';
                    }

                    ths.forEach((h, hidx) => {
                        const icon = h.querySelector('.sort-icon');
                        if (icon) {
                            if (hidx === idx) {
                                icon.className = `bi bi-arrow-${orderDir === 'asc' ? 'up' : 'down'} text-primary ms-1 small sort-icon`;
                            } else {
                                icon.className = 'bi bi-arrow-down-up text-muted ms-1 small sort-icon';
                            }
                        }
                    });

                    render();
                });
            }
        });

        // 5. Processing & Rendering
        function render() {
            // A. Search Filter
            let processed = originalRows;
            if (search) {
                const query = search.toLowerCase();
                processed = originalRows.filter(row => {
                    return row.textContent.toLowerCase().includes(query);
                });
            }

            // B. Sort
            if (orderColumnIndex !== null) {
                processed.sort((rowA, rowB) => {
                    const cellA = rowA.cells[orderColumnIndex];
                    const cellB = rowB.cells[orderColumnIndex];
                    const valA = cellA ? cellA.textContent.trim() : '';
                    const valB = cellB ? cellB.textContent.trim() : '';

                    return orderDir === 'asc'
                        ? valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' })
                        : valB.localeCompare(valA, undefined, { numeric: true, sensitivity: 'base' });
                });
            }

            // C. Slicing/Pagination
            const totalFiltered = processed.length;
            const sliced = processed.slice(start, start + length);

            // D. Render to DOM
            tableBody.innerHTML = '';
            if (sliced.length === 0) {
                tableBody.innerHTML = `
                    <tr>
                        <td colspan="${ths.length}" class="text-center py-5 text-muted">
                            <i class="bi bi-inbox fs-4 d-block mb-2"></i>
                            Tidak ada data tersedia
                        </td>
                    </tr>
                `;
            } else {
                // Find NO column to dynamically sequence
                let noColIndex = -1;
                ths.forEach((th, idx) => {
                    const title = th.textContent.trim().toLowerCase();
                    if (title === 'no') noColIndex = idx;
                });

                sliced.forEach((row, idx) => {
                    if (noColIndex !== -1 && row.cells[noColIndex]) {
                        row.cells[noColIndex].textContent = start + idx + 1;
                    }
                    tableBody.appendChild(row);
                });
            }

            // E. Update pagination & info UI
            renderPagination(originalRows.length, totalFiltered);
            renderInfo(originalRows.length, totalFiltered);
        }

        function renderPagination(totalRecords, filteredRecords) {
            if (!paginationUl) return;
            paginationUl.innerHTML = '';

            const totalPages = Math.ceil(filteredRecords / length);
            console.log('[NativeClientTable] rendering pagination. totalRecords:', totalRecords, 'filteredRecords:', filteredRecords, 'length:', length, 'totalPages:', totalPages);
            if (isNaN(totalPages) || totalPages <= 0) return;

            const currentPage = Math.floor(start / length) + 1;
            const maxRange = 2;

            // Previous Button
            const prevLi = document.createElement('li');
            prevLi.className = `page-item ${currentPage === 1 ? 'disabled' : ''}`;
            prevLi.innerHTML = `<a class="page-link rounded-start-pill px-3 shadow-none" href="#" data-page="${currentPage - 1}">Sebelumnya</a>`;
            paginationUl.appendChild(prevLi);

            for (let i = 1; i <= totalPages; i++) {
                if (i === 1 || i === totalPages || (i >= currentPage - maxRange && i <= currentPage + maxRange)) {
                    const li = document.createElement('li');
                    li.className = `page-item ${currentPage === i ? 'active' : ''}`;
                    li.innerHTML = `<a class="page-link px-3 shadow-none" href="#" data-page="${i}">${i}</a>`;
                    paginationUl.appendChild(li);
                } else if (i === currentPage - maxRange - 1 || i === currentPage + maxRange + 1) {
                    const li = document.createElement('li');
                    li.className = 'page-item disabled';
                    li.innerHTML = '<span class="page-link px-2">...</span>';
                    paginationUl.appendChild(li);
                }
            }

            // Next Button
            const nextLi = document.createElement('li');
            nextLi.className = `page-item ${currentPage === totalPages ? 'disabled' : ''}`;
            nextLi.innerHTML = `<a class="page-link rounded-end-pill px-3 shadow-none" href="#" data-page="${currentPage + 1}">Berikutnya</a>`;
            paginationUl.appendChild(nextLi);
        }

        function renderInfo(totalRecords, filteredRecords) {
            if (!tableInfo) return;

            if (filteredRecords === 0) {
                tableInfo.innerHTML = '<span class="text-muted">Menampilkan 0 data</span>';
                return;
            }

            const startNum = start + 1;
            const endNum = Math.min(start + length, filteredRecords);

            let infoText = `Menampilkan <b class="text-dark">${startNum}-${endNum}</b> dari <b class="text-dark">${filteredRecords}</b>`;
            if (filteredRecords < totalRecords) {
                infoText += ` (disaring dari <b class="text-dark">${totalRecords}</b> data)`;
            }
            tableInfo.innerHTML = infoText;
        }

        // Debounce helper
        let debounceTimeout;
        function debounce(func, delay = 300) {
            return function (...args) {
                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(() => func.apply(this, args), delay);
            };
        }

        // Event Listeners
        if (lengthMenu) {
            lengthMenu.addEventListener('change', function () {
                length = parseInt(this.value);
                start = 0;
                render();
            });
        }

        if (searchInput) {
            searchInput.addEventListener('input', debounce(function () {
                search = this.value.trim();
                start = 0;
                render();
            }, 300));
        }

        if (paginationUl) {
            paginationUl.addEventListener('click', function (e) {
                e.preventDefault();
                const link = e.target.closest('a');
                if (!link || link.parentNode.classList.contains('disabled') || link.parentNode.classList.contains('active')) {
                    return;
                }
                const targetPage = parseInt(link.dataset.page);
                start = (targetPage - 1) * length;
                render();
                table.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
        }

        // Initial render
        render();
    });

    // --- Bulk Selection Handling ---
    const updateBulkSelection = () => {
        const checkedCount = $('.row-select:checked, .row-select-trash:checked').length;
        const totalNormal = $('.row-select').length;
        const totalTrash = $('.row-select-trash').length;

        $('#bulk-selection-count').text(`${checkedCount} terpilih`);

        if (totalNormal > 0) {
            $('#check-all').prop('checked', checkedCount === totalNormal && totalNormal > 0);
        }
        if (totalTrash > 0) {
            $('#check-all-trash').prop('checked', checkedCount === totalTrash && totalTrash > 0);
        }

        if (checkedCount > 0) {
            $('#bulk-action-bar').removeClass('d-none').addClass('d-flex');
        } else {
            $('#bulk-action-bar').addClass('d-none').removeClass('d-flex');
        }

        // Contextual buttons (Trash vs Regular)
        if (pageId.includes('trash')) {
            $('#btn-bulk-restore, #btn-bulk-purge').removeClass('d-none');
            $('#btn-bulk-delete').addClass('d-none');
        } else {
            $('#btn-bulk-restore, #btn-bulk-purge').addClass('d-none');
            $('#btn-bulk-delete').removeClass('d-none');
        }
    };

    $(document).on('change', '#check-all', function () {
        $('.row-select').prop('checked', $(this).is(':checked'));
        updateBulkSelection();
    });

    $(document).on('change', '#check-all-trash', function () {
        $('.row-select-trash').prop('checked', $(this).is(':checked'));
        updateBulkSelection();
    });

    $(document).on('change', '.row-select, .row-select-trash', function () {
        updateBulkSelection();
    });

    $(document).on('click', '#btn-cancel-bulk', function () {
        $('.row-select, #check-all, .row-select-trash, #check-all-trash').prop('checked', false);
        updateBulkSelection();
    });

    // --- Bulk Action Requests ---
    const handleBulkAction = (url, ids, title, text, icon = 'warning') => {
        confirmAction({
            title: title,
            text: text,
            icon: icon,
            confirmButtonColor: (icon === 'danger' || (icon === 'warning' && text.includes('permanen'))) ? '#d33' : '#3085d6'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const formData = new FormData();
                    formData.append('module', pageId.replace('trash-', ''));
                    ids.forEach(id => formData.append('ids[]', id));

                    const response = await fetch(url, {
                        method: 'POST',
                        body: formData,
                        headers: { 'X-Requested-With': 'XMLHttpRequest' }
                    });

                    const data = await response.json();
                    if (data.status === 'success') {
                        Swal.fire('Berhasil', data.message, 'success').then(() => window.location.reload());
                    } else {
                        throw new Error(data.message);
                    }
                } catch (error) {
                    Swal.fire('Error', error.message, 'error');
                }
            }
        });
    };

    $(document).on('click', '#btn-bulk-delete', function () {
        const ids = $('.row-select:checked').map(function () { return $(this).val(); }).get();
        if (ids.length === 0) return;
        handleBulkAction(`${window.location.origin}/admin/${pageId}/bulk-delete`, ids, 'Hapus Terpilih?', `Anda akan menghapus ${ids.length} data secara sementara.`);
    });

    $(document).on('click', '#btn-bulk-restore', function () {
        const ids = $('.row-select-trash:checked').map(function () { return $(this).val(); }).get();
        if (ids.length === 0) return;
        handleBulkAction(`${window.location.origin}/admin/trash/restore`, ids, 'Pulihkan Data?', `Kembalikan ${ids.length} data ke tabel utama?`, 'info');
    });

    $(document).on('click', '#btn-bulk-purge', function () {
        const ids = $('.row-select-trash:checked').map(function () { return $(this).val(); }).get();
        if (ids.length === 0) return;
        handleBulkAction(`${window.location.origin}/admin/trash/purge`, ids, 'Hapus Permanen?', `PERINGATAN: ${ids.length} data akan dihapus selamanya dari sistem!`, 'warning');
    });

    $(document).on('click', '#btn-empty-trash', function () {
        const module = $(this).data('module');
        if (!module) return;
        confirmAction({
            title: 'Kosongkan Tong Sampah?',
            text: "Seluruh data terhapus pada modul ini akan dimusnahkan selamanya!",
            icon: 'error',
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ya, Kosongkan!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const formData = new FormData();
                    formData.append('module', module);
                    const response = await fetch(`${window.location.origin}/admin/trash/empty`, {
                        method: 'POST',
                        body: formData
                    });
                    const data = await response.json();
                    if (data.status === 'success') {
                        window.location.reload();
                    }
                } catch (e) { Swal.fire('Error', e.message, 'error'); }
            }
        });
    });
}
